export const ADD_REQUEST = 'ADD_CONTEST/ADD_REQUEST'
export const ADD_SUCCESS = 'ADD_CONTEST/ADD_SUCCESS'
export const ADD_ERROR = 'ADD_CONTEST/ADD_ERROR'
export const ADD_CLEAR = 'ADD_CONTEST/ADD_CLEAR'

export const GET_REQUEST = 'ADD_CONTEST/GET_REQUEST'
export const GET_SUCCESS = 'ADD_CONTEST/GET_SUCCESS'
export const GET_ERROR = 'ADD_CONTEST/GET_ERROR'

export const OWNER_REQUEST = 'ADD_CONTEST/OWNER_REQUEST'
export const OWNER_SUCCESS = 'ADD_CONTEST/OWNER_SUCCESS'
export const OWNER_ERROR = 'ADD_CONTEST/OWNER_ERROR'

export const TEST_REQUEST = 'ADD_CONTEST/TEST_REQUEST'
export const TEST_SUCCESS = 'ADD_CONTEST/TEST_SUCCESS'
export const TEST_ERROR = 'ADD_CONTEST/TEST_ERROR'

export const LOCATION_REQUEST = 'ADD_CONTEST/LOCATION_REQUEST'
export const LOCATION_SUCCESS = 'ADD_CONTEST/LOCATION_SUCCESS'
export const LOCATION_ERROR = 'ADD_CONTEST/LOCATION_ERROR'
export const LOCATION_CLEAR = 'ADD_CONTEST/LOCATION_CLEAR'

export const SKILL_REQUEST = 'ADD_CONTEST/SKILL_REQUEST'
export const SKILL_SUCCESS = 'ADD_CONTEST/SKILL_SUCCESS'
export const SKILL_ERROR = 'ADD_CONTEST/SKILL_ERROR'
export const SKILL_CLEAR = 'ADD_CONTEST/SKILL_CLEAR'
